// import React from "react";
// import IndianFlag from "../Images/12365115.png";
// import USAFlag from "../Images/FixedFeeProject.png";

// const orgData = [
//   {
//     name: "Sanket Raut",
//     role: "Director",
//     flag: IndianFlag,
//     color: "#0A1733",
//   },
//   {
//     name: "Gaurav Joshi",
//     role: "Director",
//     flag: USAFlag,
//     color: "#0A1733",
//   },
//   {
//     name: "Professional Engineers",
//     flag: USAFlag,
//     color: "#A6B1FF",
//   },
//   {
//     name: "Head of Design",
//     flag: IndianFlag,
//     color: "#CDA4FF",
//   },
//   {
//     name: "Team Lead (Structures)",
//     flag: IndianFlag,
//     color: "#A0E7E5",
//   },
//   {
//     name: "Team Lead (BIM & CAD)",
//     flag: IndianFlag,
//     color: "#A0E7E5",
//   },
//   {
//     name: "Sr. Design Engineers",
//     flag: IndianFlag,
//     color: "#FF5733",
//   },
//   {
//     name: "Design Engineers",
//     flag: IndianFlag,
//     color: "#FFC300",
//   },
//   {
//     name: "Modelers & Detailers",
//     flag: IndianFlag,
//     color: "#FFEB99",
//   },
// ];

// // Node component
// const OrgNode = ({ name, role, flag, color }) => (
//   <div
//     style={{
//       backgroundColor: color,
//       color: "#000",
//       padding: "10px 20px",
//       borderRadius: "6px",
//       minWidth: "150px",
//       textAlign: "center",
//       position: "relative",
//       fontWeight: "bold",
//     }}
//   >
//     {name}
//     {role && <div style={{ fontSize: "12px" }}>({role})</div>}
//     {flag && (
//       <img
//         src={flag}
//         alt="flag"
//         style={{ width: "24px", marginTop: "4px", display: "block", marginLeft: "auto", marginRight: "auto" }}
//       />
//     )}
//   </div>
// );

// // Main Chart
// const OrgChart = () => {
//   return (
//     <div style={{ textAlign: "center", padding: "40px", fontFamily: "Arial, sans-serif" }}>
//       <h1 style={{ backgroundColor: "#0A3C66", color: "#fff", padding: "20px", borderRadius: "6px" }}>
//         Organization Chart
//       </h1>

//       {/* Top Level */}
//       <div style={{ display: "flex", justifyContent: "center", gap: "40px", marginTop: "40px", position: "relative" }}>
//         <OrgNode {...orgData[0]} />
//         <OrgNode {...orgData[1]} />
//         <OrgNode {...orgData[2]} />
//       </div>

//       {/* Line from Directors to Head */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           position: "relative",
//           marginTop: "20px",
//         }}
//       >
//         {/* Horizontal line */}
//         <div
//           style={{
//             position: "absolute",
//             top: "0",
//             left: "0",
//             right: "0",
//             height: "2px",
//             borderTop: "2px dotted #555",
//             zIndex: 0,
//           }}
//         ></div>
//         <OrgNode {...orgData[3]} />
//       </div>

//       {/* Team Leads */}
//       <div style={{ display: "flex", justifyContent: "center", gap: "80px", marginTop: "60px", position: "relative" }}>
//         <OrgNode {...orgData[4]} />
//         <OrgNode {...orgData[5]} />
//       </div>

//       {/* Sr. Design Engineers */}
//       <div style={{ display: "flex", justifyContent: "center", marginTop: "60px", position: "relative" }}>
//         <OrgNode {...orgData[6]} />
//       </div>

//       {/* Bottom Engineers */}
//       <div style={{ display: "flex", justifyContent: "center", gap: "80px", marginTop: "60px", position: "relative" }}>
//         <OrgNode {...orgData[7]} />
//         <OrgNode {...orgData[8]} />
//       </div>

//       {/* Connecting lines (dotted) */}
//       <svg
//         width="100%"
//         height="400px"
//         style={{ position: "absolute", top: "120px", left: 0, pointerEvents: "none" }}
//       >
//         {/* Directors to Head of Design */}
//         <line x1="30%" y1="80" x2="50%" y2="140" stroke="#555" strokeWidth="2" strokeDasharray="4" />
//         <line x1="50%" y1="80" x2="50%" y2="140" stroke="#555" strokeWidth="2" strokeDasharray="4" />

//         {/* Head to Team Leads */}
//         <line x1="50%" y1="180" x2="35%" y2="260" stroke="#555" strokeWidth="2" strokeDasharray="4" />
//         <line x1="50%" y1="180" x2="65%" y2="260" stroke="#555" strokeWidth="2" strokeDasharray="4" />

//         {/* Team Leads to Sr. Design Engineers */}
//         <line x1="35%" y1="300" x2="50%" y2="360" stroke="#555" strokeWidth="2" strokeDasharray="4" />
//         <line x1="65%" y1="300" x2="50%" y2="360" stroke="#555" strokeWidth="2" strokeDasharray="4" />

//         {/* Sr. Design Engineers to bottom Engineers */}
//         <line x1="50%" y1="400" x2="35%" y2="460" stroke="#555" strokeWidth="2" strokeDasharray="4" />
//         <line x1="50%" y1="400" x2="65%" y2="460" stroke="#555" strokeWidth="2" strokeDasharray="4" />
//       </svg>
//     </div>
//   );
// };

// export default OrgChart;
import React from "react";
import OrgChart from "react-orgchart";
import "react-orgchart/index.css";

import IndianFlag from "../Images/12365115.png";
import USAFlag from "../Images/architectural-blueprints.jpg";
import { MdEngineering, BsPlusCircleFill } from "react-icons/md";

// Custom Node Component
const MyNodeComponent = ({ node }) => {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{
                margin: 10,
                width: "100%",
                maxWidth: 220, // flexible for mobile
                minHeight: 80,
                position: "relative"
            }} elevation={5}>
                <div style={{ display: "flex", minHeight: 80 }}>
                    <div
                        style={{
                            width: 8,
                            background: node.color || "#115293",
                            borderRadius: "5px 0px 0px 5px"
                        }}
                    ></div>
                    <div style={{ display: "flex", flex: 1, alignItems: "center", background: 'lightgrey' }}>
                        <div style={{ marginLeft: 5, marginRight: 10 }}>
                            {/* <img
                                src={node.flag || ""}
                                alt="flag"
                                style={{ width: 30, height: 20, borderRadius: 3 }}
                            /> */}
                            {/* <MdEngineering style={{ width: 30, height: 20, borderRadius: 3,color:'red' }}/> */}
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", flex: 1, alignItems: "start" }}>
                            {/* <span style={{ fontSize: "14px", fontWeight: "bold" }}>{node.role || ""}</span> */}
                            <span style={{ fontSize: "16px", fontWeight: "bold" }}>{node.name}</span>
                        </div>
                    </div>
                </div>

                {node.hasChild && (
                    <div
                        style={{
                            position: "absolute",
                            marginTop: -10,
                            marginLeft: 100,
                            background: "black",
                            fontWeight: "bold",
                            color: "#F37021",
                            border: "1px solid gray",
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer"
                        }}
                        onClick={() => {
                            console.log("Toggle children for", node.name);
                        }}
                    >
                        +
                    </div>
                )}
            </div>
        </div>
    );
};

// StructGuard Org Chart Tree
const tree = {
    name: "Head of Design",
    role: "Head of Design",
    flag: IndianFlag,
    color: "#CDA4FF",
    hasChild: true,
    children: [
        {
            name: "Team Lead (Structures)",
            role: "Team Lead",
            flag: IndianFlag,
            color: "#A0E7E5",
            hasChild: true,
            children: [
                {
                    name: "Sr. Design Engineers",
                    role: "Senior Design Engineer",
                    flag: IndianFlag,
                    color: "#FF5733",
                    hasChild: true,
                    children: [
                        {
                            name: "Design Engineers",
                            role: "Junior Design Engineer",
                            flag: IndianFlag,
                            color: "#FFC300",
                            hasChild: false
                        },
                        {
                            name: "Modelers & Detailers",
                            role: "Modelers & Detailers",
                            flag: IndianFlag,
                            color: "#FFEB99",
                            hasChild: false
                        }
                    ]
                }
            ]
        },
        {
            name: "Team Lead (BIM & CAD)",
            role: "Team Lead",
            flag: IndianFlag,
            color: "#A0E7E5",
            hasChild: true,
            // duplicate Sr node so chart lib can render
            children: [
                {
                    name: "Sr. Design Engineers",
                    role: "Senior Design Engineer",
                    flag: IndianFlag,
                    color: "#FF5733",
                    hasChild: true,
                    children: [
                        {
                            name: "Design Engineers",
                            role: "Junior Design Engineer",
                            flag: IndianFlag,
                            color: "#FFC300",
                            hasChild: false
                        },
                        {
                            name: "Modelers & Detailers",
                            role: "Modelers & Detailers",
                            flag: IndianFlag,
                            color: "#FFEB99",
                            hasChild: false
                        }
                    ]
                }
            ]
        }
    ],
    topRow: [
        { name: "Sanket Raut", role: "Director", flag: IndianFlag, color: "#0A1733" },
        { name: "Gaurav Joshi", role: "Director", flag: USAFlag, color: "#0A1733" },
        { name: "Professional Engineers", flag: USAFlag, color: "#A6B1FF" }
    ]
}


export default function App() {
    return (
        <div style={{ background:'white' }}>

            <h2 style={{ color: "#0A1733", fontSize: '60px', textAlign: 'center' }}>
                StructGuard<span style={{ color: '#f37021' }}> Organizational Chart</span>
            </h2>

            <p style={{

                maxWidth: 940,
                margin: "12px auto 32px",
                fontSize: '1rem',
                textAlign: 'center',
                marginBottom: '40px',
                fontWeight: "bold",
                fontStyle: 'italic',
                marginLeft: 'auto',
                marginRight: 'auto',
                // color: 'lightgrey',
                color: '#0A1733',
                // textTransform: "capitalize",

                // textDecoration: "underline 2px rgb(255, 101, 0)",

                textUnderlineOffset: "10px",
                letterSpacing: "2px",

            }}>
               The StructGuard Organizational Chart starts with Directors Sanket Raut and Gaurav Joshi, alongside the Professional Engineers. Reporting to them is the Head of Design, who oversees two key divisions: Team Lead (Structures) and Team Lead (BIM & CAD). Supporting them are the Senior Design Engineers, with execution handled by Design Engineers and Modelers & Detailers—ensuring precision, innovation, and seamless project delivery
            </p>
            <div id="initechOrgChart">
                <OrgChart tree={tree} NodeComponent={MyNodeComponent} />
            </div>

        </div>
    );
}
